import * as ko from "knockout";
import { searchCriteria } from "organized";

export class SolutionSearchCriteria extends searchCriteria {
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  phenomenom_code: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;

  constructor(item) {
    super(item);
    this.model_id = ko.observable(item.model_id);
    this.part_id = ko.observable(item.part_id);
    this.phenomenom_code = ko.observable(item.phenomenom_code);
    this.request_id = ko.observable(item?.request_id);
  }
}
